/**
 * Light-touch phone formatting (matches the contact-info table): normalize a
 * clean 10-digit (or 11 with a leading "1") number to (XXX) XXX-XXXX. Anything
 * with letters (names, NA, PENDING, EXT) or a non-10-digit count is left exactly
 * as entered.
 */
export function formatPhoneMaybe(v: string): string {
  if (!v || /[a-zA-Z]/.test(v)) return v;
  let d = v.replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  if (d.length !== 10) return v;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
